import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { controls } from "./Header.module.scss";

const HeaderControls = ({ className, ...props }) => (
  <div className={classnames(controls, className)} {...props} />
);

HeaderControls.propTypes = {
  className: PropTypes.string
};

export default HeaderControls;
